import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';

const CookiePolicy = () => {
  const openSettings = (e) => {
    e.nativeEvent.stopImmediatePropagation();
    if (typeof window.OneTrust !== `undefined`) {
      window.OneTrust.ToggleInfoDisplay();
    }
  };

  // Initialise the cookie policy html.
  useEffect(() => {
    if (
      typeof window !== `undefined` &&
      typeof window.OneTrust !== `undefined`
    ) {
      window.OneTrust.initializeCookiePolicyHtml();
    }
  }, []);

  return (
    <>
      <Box
        id="ot-sdk-cookie-policy"
        sx={{
          // Wrapper
          '.ot-sdk-cookie-policy': {
            width: `100% !important`
          },
          // Sections
          '.ot-sdk-cookie-policy section': {
            mb: `8 !important`
          },
          '.ot-sdk-cookie-policy section:last-child': {
            mb: `0 !important`
          },
          // Text
          '.ot-sdk-cookie-policy-group, .ot-sdk-cookie-policy-group-desc, #cookie-policy-description':
            {
              fontSize: `md !important`,
              lineHeight: `base !important`,
              color: `var(--text-color) !important`,
              mb: `8 !important`,
              '-webkit-font-smoothing': `antialiased !important`
            },
          '.ot-sdk-cookie-policy-group': {
            fontWeight: `bold !important`
          },
          // Tables
          '.ot-table-header': {
            fontWeight: `medium !important`,
            color: `var(--text-color) !important`
          },
          '.ot-sdk-container table tr td, .ot-sdk-container table tr td a, .ot-sdk-container table tr td span':
            {
              color: `var(--text-color) !important`
            },
          // Hide elements
          '.ot-sdk-cookie-policy-title, &:empty': {
            display: `none`
          }
        }}
      />
      <Box
        as="button"
        type="button"
        className="ot-sdk-show-settings"
        onClick={openSettings}
        my="8"
        sx={{
          fontSize: `md !important`,
          color: `inherit !important`,
          padding: `0 !important`,
          border: `0 !important`,
          background: `none !important`,
          textDecoration: `underline`
        }}>
        Cookie Settings
      </Box>
    </>
  );
};

export default CookiePolicy;
